export default "__VITE_ASSET__BMJ1W37h__"